<div class="checkout-container">
  <!-- Modal de erro no pagamento -->
  <app-modal
    [isOpen]="errorModalOpen"
    [title]="errorModalTitle"
    [message]="errorModalMessage"
    confirmButtonText="OK"
    (close)="closeErrorModal()"
    (confirm)="closeErrorModal()">
  </app-modal>
  <div class="checkout-header">
    <div class="header-actions">
      <button class="back-button" (click)="navigateToPurchases()">
        <span class="back-icon"></span>
        Voltar
      </button>
      <h1>Checkout</h1>
    </div>
  </div>

  <div class="checkout-content" *ngIf="!loading && !error && purchase">
    <div class="purchase-details">
      <h2>Detalhes da compra</h2>
      <div class="details-grid">
        <div class="detail-item">
          <span class="detail-label">Valor total:</span>
          <span class="detail-value">{{
            purchase.Value | currencyFix | currency : "BRL"
          }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Pass (Corte):</span>
          <span class="detail-value"
            >{{ purchase.QuantityHaircut }} unidades</span
          >
        </div>
        <div class="detail-item">
          <span class="detail-label">Pass (Barba):</span>
          <span class="detail-value"
            >{{ purchase.QuantityBeard }} unidades</span
          >
        </div>
      </div>
    </div>

    <div class="payment-methods" *ngIf="!success">
      <h2>Forma de pagamento</h2>
      <div class="payment-selector">
        <div
          class="payment-option"
          [class.active]="paymentMethod === 'credit-card'"
          (click)="setPaymentMethod('credit-card')"
        >
          <span class="payment-icon credit-card-icon"></span>
          <span>Cartão de Crédito</span>
        </div>
        <!-- <div
          class="payment-option"
          [class.active]="paymentMethod === 'pix'"
          (click)="setPaymentMethod('pix')"
        >
          <span class="payment-icon pix-icon"></span>
          <span>PIX</span>
        </div> -->
      </div>

      <div class="payment-form" *ngIf="paymentMethod === 'credit-card'">
        <div class="form-group">
          <label for="card-number">Número do Cartão</label>
          <input
            type="text"
            id="card-number"
            [(ngModel)]="cardNumber"
            mask="0000 0000 0000 0000"
            placeholder="0000 0000 0000 0000"
            required
          />
        </div>
        <div class="form-row">
          <div class="form-group">
            <label for="cardName">Nome no Cartão</label>
            <input
              type="text"
              id="cardName"
              [(ngModel)]="cardName"
              placeholder="Nome como aparece no cartão"
            />
          </div>
          <div class="form-group">
            <label for="cardDocument">CPF/CNPJ do Titular</label>
            <input
              type="text"
              id="cardDocument"
              [(ngModel)]="cardDocument"
              mask="000.000.000-00||00.000.000/0000-00"
              placeholder="CPF ou CNPJ do titular"
            />
          </div>
        </div>
        <div class="form-row">
          <div class="form-group">
            <label for="card-expiry">Validade</label>
            <input
              type="text"
              id="card-expiry"
              [(ngModel)]="cardExpiry"
              mask="00/00"
              placeholder="MM/AA"
              required
            />
          </div>
          <div class="form-group">
            <label for="card-cvc">Código de Segurança</label>
            <input
              type="text"
              id="card-cvc"
              [(ngModel)]="cardCvv"
              mask="000"
              placeholder="123"
              required
            />
          </div>
        </div>
      </div>

      <div class="payment-form pix-container" *ngIf="paymentMethod === 'pix'">
        <p>
          Ao clicar em "Pagar com PIX", você receberá um QR Code para pagamento.
        </p>
      </div>

      <div class="payment-actions">
        <button
          class="pay-button"
          [disabled]="processing"
          (click)="processPayment()"
        >
          <span *ngIf="!processing">{{
            paymentMethod === "credit-card"
              ? "Pagar com Cartão"
              : "Pagar com PIX"
          }}</span>
          <span *ngIf="processing">Processando...</span>
        </button>
      </div>
    </div>

    <div class="payment-success" *ngIf="success">
      <div class="success-message">
        <div class="success-icon" [class.fixed-icon]="true"></div>
        <h2>Pagamento processado!</h2>
        <p *ngIf="paymentMethod === 'credit-card'">
          Seu pagamento foi processado com sucesso. Seus pass já estão
          disponíveis para uso.
        </p>
      </div>

      <div class="pix-details" *ngIf="paymentMethod === 'pix' && pixQrCode">
        <h3>Finalize seu pagamento via PIX</h3>
        <p>Escaneie o QR Code abaixo ou copie o código PIX:</p>

        <div class="qr-code">
          <img [src]="pixQrCode" alt="QR Code PIX" />
        </div>

        <div class="pix-code">
          <textarea readonly>{{ pixCode }}</textarea>
          <button class="copy-button" (click)="copyPixCode()">
            {{ pixCopied ? "Copiado!" : "Copiar" }}
          </button>
        </div>

        <p class="pix-instructions">
          Após realizar o pagamento, seus pass estarão disponíveis em instantes.
        </p>

        <div class="pix-expiration" *ngIf="pixExpirationDate">
          <p><strong>Validade do PIX:</strong> {{ pixExpirationDate }}</p>
        </div>
      </div>

      <div class="back-button">
        <button (click)="navigateToPurchases()">Voltar para Compras</button>
      </div>
    </div>
  </div>

  <div class="loading-container" *ngIf="loading">
    <div class="loading-spinner"></div>
    <p>Carregando detalhes da compra...</p>
  </div>

  <div class="error-container" *ngIf="error">
    <div class="error-icon"></div>
    <h2>Erro ao carregar compra</h2>
    <p>
      Não foi possível carregar os detalhes da compra. Por favor, tente
      novamente.
    </p>
    <button (click)="navigateToPurchases()">Voltar para Compras</button>
  </div>
</div>

<!-- Modal de erro no pagamento -->
<app-modal
  [isOpen]="errorModalOpen"
  [title]="errorModalTitle"
  [message]="errorModalMessage"
  confirmButtonText="OK"
  (close)="closeErrorModal()"
  (confirm)="closeErrorModal()">
</app-modal>
